module.exports = __webpack_public_path__ + "media/images/os_cara/glin-igor-a42f8edb5b21b32a714b04ae7f41bc22.jpg";